import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import HomeCurrency from '../components/HomeCurrency';
import HomeTransactions from '../components/HomeTransactions';
import { getTransactions, getMoreTransactions, downloadTransactionsInfo } from '../redux/actions/transactions';
import { getMerchantBalances } from '../redux/actions/merchantData';
import useWindowSize from '../utils/resizeHook';
import './Home.scss';
import { AppConfig } from '../config';
import WizzardBlock from '../components/WizzardBlock/WizardBlock';
import { useNftSupport } from '../utils/nftSupportContext';
import moment from 'moment/moment';
import { identity } from '../utils/getIdentity';
import WizzardBlockInex from '../components/WizzardBlock/WizzardBlockInex';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const parseStoredBoolean = (key, fallback = false) => {
  const rawValue = localStorage.getItem(key);

  if (rawValue === null || rawValue === undefined || rawValue === 'undefined') {
    return fallback;
  }

  try {
    const parsedValue = JSON.parse(rawValue);
    return typeof parsedValue === 'boolean' ? parsedValue : fallback;
  } catch (error) {
    return fallback;
  }
};

let appInitialized = false;

const Home = ({
  merchantId,
  networkFilter,
  transactions,
  transactionsFetching,
  moreTransactionsFetching,
  countItem,
  merchantBalances,
  currencies,
  balancesFetching,
  getTransactions,
  getMoreTransactions,
  getMerchantBalances,
  balancesTotal,
  downloadTransactionsInfo,
  transInfoFetching,
  storedValue,
  storedValueInex,
  merchantData,
}) => {
  const query = useQuery();

  const defaultParams = {
    search: query.get('checkoutId') || '',
    order: 'DESC',
    currencyId: '',
    type: 'replenishment,withdrawal,Error,refund,multisend,InternalTransfer,ExternalCall,SystemFee',
    page: 1,
    limit: 7,
    typeNetwork: networkFilter,
    onlyNft: false,
    nftType: undefined,
    withoutNft: !AppConfig.showNftBlock ? true : parseStoredBoolean('hideNft', false),
  };

  const [socket, setSocket] = useState(undefined);
  const [currencyId, setCurrencyId] = useState(defaultParams.currencyId);
  const [search, setSearch] = useState(defaultParams.search);
  const [order, setOrder] = useState(defaultParams.order);
  const [type, setType] = useState(defaultParams.type);
  const [page, setPage] = useState(defaultParams.page);
  const [onlyNft, setOnlyNft] = useState(defaultParams.onlyNft);
  const [nftType, setNftType] = useState(defaultParams.nftType);
  const [isHideZeroBalances, setIsHideZeroBalances] = useState(parseStoredBoolean('cpayHideZeroBalances', false));
  const [times, setTimes] = useState([]);
  const [hideNft, setHideNft] = useState(defaultParams.withoutNft);
  const limit = defaultParams.limit;
  const { currentWidth } = useWindowSize();

  const dateFrom = times?.length === 2 && Date.parse(moment(times[0]).format('YYYY-MM-DD') + 'T00:00:00');
  const dateTo = times?.length === 2 && Date.parse(moment(times[1]).format('YYYY-MM-DD') + 'T23:59:59');

  const { showNftSupportBlock } = useNftSupport();

  const [walletVersion, setWalletVersion] = useState(undefined);
  const initializedForMerchant = useRef(null);
  const walletVersionRef = useRef(walletVersion);
  walletVersionRef.current = walletVersion;

  useEffect(() => {
    const handleWalletVersionChange = () => {
      const wv = localStorage.getItem('walletVersion');
      if (wv && wv !== walletVersionRef.current) {
        setWalletVersion(wv);
      }
    };
    window.addEventListener('walletVersionChange', handleWalletVersionChange);
    return () => window.removeEventListener('walletVersionChange', handleWalletVersionChange);
  }, []);

  useEffect(() => {
    if (merchantData?.settingWallet?.version) {
      const version = merchantData.settingWallet.version;
      if (initializedForMerchant.current !== merchantId) {
        const wv = localStorage.getItem('walletVersion');
        if (wv) {
          setWalletVersion(wv);
        } else {
          setWalletVersion(version);
        }
        initializedForMerchant.current = merchantId;
      }
    }
  }, [merchantData]);

  useEffect(() => {
    if (merchantId && networkFilter && walletVersion) {
      console.log(
        'getMerchantBalances called from Home.jsx initial useEffect, merchantId:', 
        merchantId,
        'networkFilter:',
        networkFilter,
        'walletVersion:',
        walletVersion
      );
      getMerchantBalances(merchantId, networkFilter, true, false, walletVersion);
      appInitialized = true;

      setSearch(defaultParams.search);
      setOrder(defaultParams.order);
      setType(defaultParams.type);
      setPage(defaultParams.page);
      setOnlyNft(defaultParams.onlyNft);
      setNftType(defaultParams.nftType);
      setHideNft(defaultParams.withoutNft);

      getTransactions(merchantId, {
        search,
        order,
        currencyId: currencyId || undefined,
        type,
        page,
        limit,
        fromUSD: 0.01,
        typeNetwork: networkFilter,
        onlyNft: onlyNft ? true : undefined,
        nftType: onlyNft ? nftType : undefined,
        withoutNft: hideNft ? true : undefined,
        from: dateFrom || undefined,
        to: dateTo || undefined,
        walletVersion,
      });
    }
  }, [merchantId, networkFilter]);

  useEffect(() => {
    if (merchantId && networkFilter && walletVersion) {
      getMerchantBalances(merchantId, networkFilter, true, false, walletVersion);

      setPage(defaultParams.page);

      getTransactions(merchantId, {
        search,
        order,
        currencyId: currencyId || undefined,
        type,
        page,
        limit,
        fromUSD: 0.01,
        typeNetwork: networkFilter,
        onlyNft: onlyNft ? true : undefined,
        nftType: onlyNft ? nftType : undefined,
        withoutNft: hideNft ? true : undefined,
        from: dateFrom || undefined,
        to: dateTo || undefined,
        walletVersion,
      });
    }
  }, [walletVersion]);

  useEffect(() => {
    const handleWalletVersionChange = () => {
      if (merchantId) {
        const wv = localStorage.getItem('walletVersion');
        if (wv) {
          console.log(
            'getMerchantBalances called from Home.jsx walletVersionChange handler, merchantId:',
            merchantId,
            'networkFilter:',
            networkFilter,
            'walletVersion:',
            wv
          );
          getMerchantBalances(merchantId, networkFilter, true, false, wv);
        }
      }
    };
    window.addEventListener('walletVersionChange', handleWalletVersionChange);
    return () => window.removeEventListener('walletVersionChange', handleWalletVersionChange);
  }, [merchantId, networkFilter, merchantData, getMerchantBalances]);

  useEffect(() => {
    localStorage.setItem('currId', currencyId);
    localStorage.setItem('search', search);
    localStorage.setItem('order', order);
    localStorage.setItem('type', type);
    localStorage.setItem('page', page);
    localStorage.setItem('nftType', nftType);
    localStorage.setItem('onlyNft', onlyNft);
    localStorage.setItem('hideNft', hideNft);
  }, [currencyId, search, order, type, page]);

  useEffect(() => {
    setPage(defaultParams.page);
    if (merchantId && walletVersion) {
      getTransactions(merchantId, {
        search,
        order,
        currencyId: currencyId || undefined,
        type,
        page: defaultParams.page,
        limit,
        fromUSD: 0.01,
        typeNetwork: networkFilter,
        onlyNft: onlyNft ? true : undefined,
        nftType: onlyNft ? nftType : undefined,
        withoutNft: hideNft ? true : undefined,
        from: dateFrom || undefined,
        to: dateTo || undefined,
        walletVersion,
      });
    }
  }, [currencyId, order, type, onlyNft, nftType, hideNft, times]);

  useEffect(() => {
    if (page > 1) {
      getMoreTransactions(merchantId, {
        search,
        order,
        currencyId: currencyId || undefined,
        type,
        page,
        limit,
        fromUSD: 0.01,
        typeNetwork: networkFilter,
        onlyNft: onlyNft ? true : undefined,
        nftType: onlyNft ? nftType : undefined,
        withoutNft: hideNft ? true : undefined,
        from: dateFrom || undefined,
        to: dateTo || undefined,
        walletVersion,
      });
    }
  }, [page]);

  useEffect(() => {
    socket && socket.disconnect();
    // setSocket(undefined);
    createSocket(merchantId);
  }, [merchantId]);

  const createSocket = merchantId => {
    const io = window.io;
    const socket = io(process.env.REACT_APP_API_URL, {
      allowEIO3: true,
      withCredentials: true,
    });
    socket.on('connect', () => {
      socket.emit('sign-in-merchant', { token: localStorage.getItem('authToken'), merchantId });
      setSocket(socket);
    });

    socket.on('pendingTransactionStatus', data => {
      if (merchantId) {
        getTransactions(
          merchantId,
          {
            search: localStorage.getItem('search'),
            order: localStorage.getItem('order'),
            currencyId: localStorage.getItem('currId') || undefined,
            type: localStorage.getItem('type'),
            page: defaultParams.page,
            limit,
            fromUSD: 0.01,
            typeNetwork: networkFilter,
            onlyNft: localStorage.getItem('onlyNft') === 'true' ? true : undefined,
            nftType:
              localStorage.getItem('onlyNft') === 'true' &&
              ['erc721', 'erc1155'].includes(localStorage.getItem('nftType'))
                ? localStorage.getItem('nftType')
                : undefined,
            withoutNft: localStorage.getItem('hideNft') === 'true' ? true : undefined,
            from: dateFrom || undefined,
            to: dateTo || undefined,
            walletVersion: localStorage.getItem('walletVersion'),
          },
          true
        );
      }
    });

    socket.on('confirmedTransaction', data => {
      // console.log('incomingTransaction: ', data);
      if (merchantId && networkFilter === data.typeNetwork) {
        getTransactions(
          merchantId,
          {
            search: localStorage.getItem('search'),
            order: localStorage.getItem('order'),
            currencyId: localStorage.getItem('currId') || undefined,
            type: localStorage.getItem('type'),
            page: defaultParams.page,
            limit,
            fromUSD: 0.01,
            typeNetwork: data.typeNetwork,
            onlyNft: localStorage.getItem('onlyNft') === 'true' ? true : undefined,
            nftType:
              localStorage.getItem('onlyNft') === 'true' &&
              ['erc721', 'erc1155'].includes(localStorage.getItem('nftType'))
                ? localStorage.getItem('nftType')
                : undefined,
            withoutNft: localStorage.getItem('hideNft') === 'true' ? true : undefined,
            from: dateFrom || undefined,
            to: dateTo || undefined,
            walletVersion: localStorage.getItem('walletVersion'),
          },
          true
        );

        if (data.systemStatus === 'Done') {
          console.log(
            'getMerchantBalances called from Home.jsx updatedTransaction handler, merchantId:',
            merchantId,
            'networkFilter:',
            networkFilter,
            'walletVersion:',
            localStorage.getItem('walletVersion')
          );
          getMerchantBalances(merchantId, networkFilter, true, false, localStorage.getItem('walletVersion'));
        }
        setPage(defaultParams.page);
      }
    });
    socket.on('incomingTransaction', data => {
      //  console.log('incomingTransaction: ', data);
      if (merchantId && networkFilter === data.typeNetwork) {
        getTransactions(
          merchantId,
          {
            search: localStorage.getItem('search'),
            order: localStorage.getItem('order'),
            currencyId: localStorage.getItem('currId') || undefined,
            type: localStorage.getItem('type'),
            page: defaultParams.page,
            limit,
            fromUSD: 0.01,
            typeNetwork: data.typeNetwork,
            onlyNft: localStorage.getItem('onlyNft') === 'true' ? true : undefined,
            nftType:
              localStorage.getItem('onlyNft') === 'true' &&
              ['erc721', 'erc1155'].includes(localStorage.getItem('nftType'))
                ? localStorage.getItem('nftType')
                : undefined,
            withoutNft: localStorage.getItem('hideNft') === 'true' ? true : undefined,
            from: dateFrom || undefined,
            to: dateTo || undefined,
            walletVersion: localStorage.getItem('walletVersion'),
          },
          true
        );
        if (data.systemStatus === 'Done') {
          console.log(
            'getMerchantBalances called from Home.jsx outgoingTransaction handler, merchantId:',
            merchantId,
            'networkFilter:',
            networkFilter,
            'walletVersion:',
            localStorage.getItem('walletVersion')
          );
          getMerchantBalances(merchantId, networkFilter, true, false, localStorage.getItem('walletVersion'));
        }
        setPage(defaultParams.page);
      }
    });
    socket.on('swapStatusUpdate', data => {
      if (merchantId) {
        getTransactions(
          merchantId,
          {
            search: localStorage.getItem('search'),
            order: localStorage.getItem('order'),
            currencyId: localStorage.getItem('currId') || undefined,
            type: localStorage.getItem('type'),
            page: defaultParams.page,
            limit,
            fromUSD: 0.01,
            typeNetwork: networkFilter,
            onlyNft: localStorage.getItem('onlyNft') === 'true' ? true : undefined,
            nftType:
              localStorage.getItem('onlyNft') === 'true' &&
              ['erc721', 'erc1155'].includes(localStorage.getItem('nftType'))
                ? localStorage.getItem('nftType')
                : undefined,
            withoutNft: localStorage.getItem('hideNft') === 'true' ? true : undefined,
            from: dateFrom || undefined,
            to: dateTo || undefined,
            walletVersion: localStorage.getItem('walletVersion'),
          },
          true
        );
        if (data.systemStatus === 'Done') {
          console.log(
            'getMerchantBalances called from Home.jsx swapStatusUpdate socket, merchantId:',
            merchantId,
            'networkFilter:',
            networkFilter,
            'walletVersion:',
            localStorage.getItem('walletVersion')
          );
          getMerchantBalances(merchantId, networkFilter, true, false, localStorage.getItem('walletVersion'));
        }
        setPage(defaultParams.page);
      }
    });
  };

  const setTime = value => setTimes(value);

  const submitSearch = search => {
    setSearch(search);
    setPage(defaultParams.page);
    getTransactions(merchantId, {
      search,
      order,
      currencyId: currencyId || undefined,
      type,
      typeNetwork: networkFilter,
      page: defaultParams.page,
      limit,
      fromUSD: 0.01,
      onlyNft: onlyNft ? true : undefined,
      nftType: onlyNft ? nftType : undefined,
      withoutNft: hideNft ? true : undefined,
      from: dateFrom || undefined,
      to: dateTo || undefined,
      walletVersion,
    });
  };

  const resetFilters = () => {
    query.delete('checkoutId');
    const newurl = window.location.protocol + '//' + window.location.host + window.location.pathname;
    window.history.pushState({ path: newurl }, '', newurl);

    setSearch('');
    setOrder(defaultParams.order);
    setType(defaultParams.type);
    setPage(defaultParams.page);
    setOnlyNft(defaultParams.onlyNft);
    setNftType(defaultParams.nftType);
    setHideNft(defaultParams.withoutNft);
    setTimes([]);

    console.log(
      'getMerchantBalances called from Home.jsx cleanFilter handler, merchantId:',
      merchantId,
      'networkFilter:',
      networkFilter,
      'walletVersion:',
      walletVersion
    );
    getMerchantBalances(merchantId, networkFilter, true, false, walletVersion);
    getTransactions(
      merchantId, { 
        ...defaultParams, 
        currencyId: currencyId || undefined, 
        search: '', 
        fromUSD: 0.01, 
        walletVersion, 
      });
  };

  return (
    <div className="home-page">
      <div className="home-page__left">
        {currentWidth < 1024 && storedValue && identity !== 'inex' && AppConfig.showNftBlock && <WizzardBlock />}
        {currentWidth < 1024 && storedValueInex && identity === 'inex' && <WizzardBlockInex />}
        <HomeCurrency
          merchantBalances={merchantBalances}
          balancesFetching={balancesFetching}
          currencies={currencies}
          currencyId={currencyId}
          setCurrencyId={setCurrencyId}
          isHideZeroBalances={isHideZeroBalances}
          setIsHideZeroBalances={setIsHideZeroBalances}
          balancesTotal={balancesTotal}
          getMerchantBalances={getMerchantBalances}
          merchantId={merchantId}
          networkFilter={networkFilter}
        />
      </div>
      <div className="home-page__right">
        {currentWidth >= 1024 && storedValue && AppConfig.showNftBlock && identity !== 'inex' && <WizzardBlock />}
        {currentWidth >= 1024 && storedValueInex && identity === 'inex' && <WizzardBlockInex />}
        <HomeTransactions
          setTime={setTime}
          currencyId={currencyId}
          merchantBalances={merchantBalances}
          transactions={transactions}
          transactionsFetching={transactionsFetching}
          moreTransactionsFetching={moreTransactionsFetching}
          currencies={currencies}
          networkFilter={networkFilter}
          countItem={countItem}
          page={page}
          setPage={setPage}
          search={search}
          setSearch={setSearch}
          order={order}
          setOrder={setOrder}
          type={type}
          setType={setType}
          submitSearch={submitSearch}
          resetFilters={resetFilters}
          downloadTransactionsInfo={downloadTransactionsInfo}
          merchantId={merchantId}
          transInfoFetching={transInfoFetching}
          onlyNft={onlyNft}
          setOnlyNft={setOnlyNft}
          setHideNft={setHideNft}
          nftType={nftType}
          setNftType={setNftType}
          hideNft={hideNft}
          getTransactions={getTransactions}
          limit={limit}
          dateFrom={dateFrom}
          dateTo={dateTo}
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  merchantId: state.transactions.merchantId,
  networkFilter: state.networkFilter,
  transactions: state.transactions.data,
  transactionsFetching: state.transactions.fetching,
  moreTransactionsFetching: state.transactions.loadMoreFetching,
  countItem: state.transactions.countItem,
  merchantBalances: state.merchantData.balances.balances || [],
  currencies: state.currencies.data,
  balancesFetching: state.merchantData.fetching,
  balancesTotal: state.merchantData.balances.total,
  transInfoFetching: state.transactions.download.fetching,
  merchantData: state.merchantData.data,
});

const mapDispatchToProps = dispatch => ({
  getTransactions: getTransactions(dispatch),
  getMoreTransactions: getMoreTransactions(dispatch),
  getMerchantBalances: getMerchantBalances(dispatch),
  downloadTransactionsInfo: downloadTransactionsInfo(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
